module.exports = __webpack_public_path__ + "img/759ad80.jpg";